/** Decorative drawer of index cards with brass label holders: the archive the app opens onto. */
export function ArchiveMotif() {
  const rows = Array.from({ length: 7 }, (_, i) => i);
  return (
    <svg viewBox="0 0 420 300" aria-hidden="true" focusable="false" className="w-full max-w-md">
      {rows.map((i) => {
        const y = 24 + i * 38;
        const x = 18 + (i % 3) * 10;
        const width = 360 - (i % 2) * 24;
        return (
          <g key={i} opacity={1 - i * 0.09}>
            <rect x={x} y={y} width={width} height={30} rx={7} fill="none" stroke="rgb(255 255 255 / 0.16)" />
            <rect
              x={x + 22 + ((i * 37) % 140)}
              y={y - 7}
              width={58}
              height={12}
              rx={3}
              fill="#d9a443"
              opacity={0.85}
            />
            <line
              x1={x + 18}
              x2={x + 120}
              y1={y + 18}
              y2={y + 18}
              stroke="rgb(255 255 255 / 0.22)"
              strokeWidth={3}
              strokeLinecap="round"
            />
          </g>
        );
      })}
    </svg>
  );
}
